<template>
    <v-card :color="pushNotification.color" dark :elevation="elevation">
        <v-card-text class="white--text">
            <v-row align="center">
                <v-col>
                    <div class="text-subtitle-1 font-weight-bold">
                        {{ pushNotification.data.title }}
                    </div>
                    <div class="text-body-2">
                        {{ pushNotification.data.text }}
                    </div>
                    <div class="pt-2">
                        <v-btn :href="pushNotification.data.url" target="_blank" outlined>
                            Openen
                            <v-icon right>mdi-open-in-new</v-icon>
                        </v-btn>
                    </div>
                </v-col>
                <v-col cols="auto" v-if="pushNotification.closable">
                    <v-btn @click="close" icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import AbstractNotification from "@/components/General/PushNotification/AbstractNotification";

export default {
    extends: AbstractNotification,
}
</script>
